import React, { Component, Fragment } from 'react';
import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from "react-bootstrap-table";
import {RenderMoneda} from "../../../Utils/renderField/renderTableField";
import { RenderDateTime } from "../../../Utils/renderField/renderReadField";

export default class GridloteInventario extends Component {

    render() {
        const { loader, item, pageLote, listarLote, onPageChange, onSortChange} = this.props;
        return (
            <Fragment>
                <Grid
                    hover
                    striped
                    data={item}
                    loading={loader}
                    page={pageLote}
                    className="reporte-table"
                    onPageChange={listarLote} onSortChange={onSortChange}
                >
                    <TableHeaderColumn
                        isKey
                        dataField="id"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell) => {
                            cell ? cell : ''
                            }
                        }
                        width="5%"
                    />
                    <TableHeaderColumn
                        dataField="lote_creado"
                        dataSort
                        className='reporte-table'
                        dataAlign="center"
                        dataFormat={(cell, row) => (
                            cell ? <RenderDateTime value={cell} /> : "Sin registro"
                        )}
                    >
                        FECHA
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="lote_no"
                        dataSort
                        className='reporte-table'
                        dataAlign="center"
                        dataFormat={(cell, row) => (
                            cell ? cell : "Sin registro"
                        )}
                    >
                        LOTE
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="costo_total"
                        dataSort
                        className='reporte-table'
                        dataAlign="center"
                        dataFormat={(cell) => ( cell  || cell == 0 ? <RenderMoneda monto={cell}/> : "Sin registro" )}
                    >
                        COSTO TOTAL
                    </TableHeaderColumn>
                </Grid>
            </Fragment>
        )
    }

}
